import React from "react";
import { connect } from "react-redux";
import MemberStatements from "../components/Statements";
import {
  fetchBillingStatements,
  updateStatementStatus,
  createStatement,
  closeSnackbar,
  setSelectedStatusForFetch,
} from "../actions/statements";
import selectStatementsContainer from "../selectors/statements";

const MemberStatementContainer = (props) => <MemberStatements {...props} />;

const mapStateToProps = (state) => ({
  member: state.selectedMember,
  adminUser: state.user,
  ...selectStatementsContainer(state)(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedStatusForFetch: (status) => {
    dispatch(setSelectedStatusForFetch(status));
  },
  doFetchBillingStatements: ({ accountID, status, inReview }) => {
    dispatch(fetchBillingStatements({ accountID, status, inReview }));
  },
  doUpdateStatementStatus: ({ statementIDs, status, errorReason, inReview = false, isNotificationDisabled = false }) => {
    dispatch(updateStatementStatus({ statementIDs, status, errorReason, inReview, isNotificationDisabled }));
  },
  doCreateStatement: ({ spsd, sped, isFinal, memberId, accountID }) => {
    dispatch(createStatement({ spsd, sped, isFinal, memberId, accountID }));
  },
  closeSnackbar: () => {
    dispatch(closeSnackbar());
  },
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberStatementContainer);
